define('geo/latlng',["require", "exports", "../util/convert"], function (require, exports, convert_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.formatLatLngAlt = exports.formatLatLng = void 0;
    function formatLatLng(point) {
        if (point && point.lat !== undefined && point.lng !== undefined) {
            return point.lat.toFixed(6) + ", " + point.lng.toFixed(6);
        }
        else {
            return "";
        }
    }
    exports.formatLatLng = formatLatLng;
    function formatLatLngAlt(point) {
        if (!point) {
            return "";
        }
        else if (isNaN(point.alt)) {
            return formatLatLng(point);
        }
        else if (point.lat !== undefined && point.lng !== undefined) {
            return point.lat.toFixed(6) + ", " + point.lng.toFixed(6) + ", " + convert_1.default.distance.localString(point.alt);
        }
        else {
            return "";
        }
    }
    exports.formatLatLngAlt = formatLatLngAlt;
});
//# sourceMappingURL=/assets/javascripts/geo/latlng.js.map;
